module.exports = __webpack_public_path__ + "img/project.ff8b6121.png";